<template>
  <v-img
    class="grow hidden-sm-and-down"
    contain
    max-height="200"
    width="100%"
    position="bottom left"
    :src="require('../../../static/img/bubbles2.png')"
  />
</template>

<script>
  export default {
    name: 'BaseBubble2',
  }
</script>



// WEBPACK FOOTER //
// src/components/base/Bubble2.vue